var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWechat = props => {
  const {
    size,
    color,
    svgProps
  } = props;
  props = {
    width: size || 24,
    height: size || 24,
    color: color || 'currentColor',
    ...svgProps
  };
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 180 180",
    width: 28,
    height: 28
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "wechat_svg__a",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18d121"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1bbc22"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#wechat_svg__a)",
    d: "M0 0h180v180H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M143.366 132.34c8.565-6.208 14.04-15.392 14.04-25.594 0-18.703-18.193-33.862-40.634-33.862-22.442 0-40.634 15.159-40.634 33.862 0 18.7 18.192 33.86 40.634 33.86a48.05 48.05 0 0013.263-1.856 4.08 4.08 0 011.196-.178c.778 0 1.489.237 2.156.625l8.896 5.134c.248.144.488.253.783.253a1.354 1.354 0 001.354-1.355c0-.333-.133-.67-.218-.989-.052-.191-1.148-4.28-1.83-6.83-.079-.286-.143-.563-.143-.864a2.706 2.706 0 011.137-2.207m-40.14-31.01a5.417 5.417 0 01-5.416-5.42 5.418 5.418 0 115.416 5.42m27.09 0a5.418 5.418 0 11.002-10.837 5.418 5.418 0 01-.002 10.837zM71.26 35.5c24.327 0 44.488 14.845 48.16 34.257a54.115 54.115 0 00-2.648-.071c-24.56 0-44.471 16.593-44.471 37.058 0 3.452.579 6.791 1.639 9.96a57.725 57.725 0 01-18.595-2.164 4.889 4.889 0 00-1.434-.215c-.936 0-1.785.286-2.589.75l-10.675 6.163c-.297.171-.587.303-.94.303a1.624 1.624 0 01-1.625-1.625c0-.402.16-.804.263-1.188l2.196-8.196c.093-.345.171-.676.171-1.036a3.249 3.249 0 00-1.364-2.65C29.068 99.4 22.5 88.379 22.5 76.136 22.5 53.693 44.33 35.5 71.26 35.5zM55.006 69.633a6.5 6.5 0 006.502-6.502 6.5 6.5 0 00-6.502-6.501 6.5 6.5 0 00-6.5 6.5 6.501 6.501 0 006.5 6.503zm32.509 0a6.502 6.502 0 100-13.003 6.5 6.5 0 00-6.502 6.5 6.5 6.5 0 006.502 6.503z",
    fill: "#FFF",
    fillRule: "evenodd"
  })));
};
export default SvgWechat;